import { Link, Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { BookOpen, ExternalLink, LogOut, Settings, Loader2 } from "lucide-react";
import { toast } from "sonner";
import Logo from "@/components/Logo";
import { useOwner } from "@/components/admin/AdminContext";
import { adminApi, apiError } from "@/lib/blogApi";

export const AdminShell = () => {
  const { user, checking, setUser } = useOwner();
  const location = useLocation();
  const navigate = useNavigate();
  const login = location.pathname === "/admin/login";
  if (checking) return <div className="min-h-screen flex items-center justify-center gap-3 text-corpblue" data-testid="admin-session-loading"><Loader2 className="animate-spin h-5 w-5" />Checking your session…</div>;
  if (!user && !login) return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  if (login) return user ? <Navigate to="/admin/posts" replace /> : <Outlet />;
  const logout = async () => {
    try { await adminApi.post("/auth/logout"); setUser(null); navigate("/admin/login"); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="min-h-screen bg-paper" data-testid="admin-workspace">
      <header className="bg-ink-deep text-white border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 flex flex-wrap gap-5 items-center justify-between">
          <Link to="/admin/posts" data-testid="admin-brand-link"><Logo light testid="admin-logo" /></Link>
          <nav className="flex flex-wrap gap-4 items-center text-sm" aria-label="Owner navigation" data-testid="admin-navigation">
            <Link to="/admin/posts" className="admin-nav-link" data-testid="admin-posts-link"><BookOpen size={16} />Posts</Link>
            <Link to="/admin/settings" className="admin-nav-link" data-testid="admin-settings-link"><Settings size={16} />Account</Link>
            <Link to="/insights" target="_blank" className="admin-nav-link" data-testid="admin-website-link">View website<ExternalLink size={14} /></Link>
            <button onClick={logout} className="admin-nav-link" data-testid="admin-logout-button"><LogOut size={16} />Sign out</button>
          </nav>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-14"><Outlet /></main>
    </div>
  );
};